import { InjectionToken } from '@angular/core';

/**
 * Base URL for trackermanager. Apps provide it from their environment file (e.g.
 * `https://api.dev.wheere.tech/trackermanager`). Mirrors the BASE_PATH token pattern of the
 * generated `@wheere/api-tracker` client so this lib can swap between hand-written calls and
 * the generated client without consumer changes.
 */
export const TRACKERMANAGER_BASE_PATH = new InjectionToken<string>('TRACKERMANAGER_BASE_PATH');
